// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-swap[data-v-274fca22]{z-index:2;transition:all .5s ease;opacity:0;position:absolute;top:30px;right:30px;width:50px;height:50px;background-color:#000;border-radius:50%}.v-swap img[data-v-274fca22]{position:absolute;width:15px;height:15px;top:50%;left:50%;transform:translate(-50%,-50%);filter:invert(1)}", ""]);
// Exports
module.exports = exports;
